<import-file
  [title]="'Import Document'"
  [isGeneric]="false"
  [documentType]="documentType.Agent"
  [attachmentId]="attachmentId"
  [requiredColumns]="contractRequiredColumns"
>
</import-file>
